import { render, staticRenderFns } from "./FlightUploadsForm.vue?vue&type=template&id=59120242&"
import script from "./FlightUploadsForm.vue?vue&type=script&lang=js&"
export * from "./FlightUploadsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports